// extracted by mini-css-extract-plugin
export var button = "Button-module--button--b4ff0";
export var isOutlined = "Button-module--isOutlined--cf5cc";
export var isSecondary = "Button-module--isSecondary--25e92";